<!--
 * @Description: 首页/企业认证信息
 * @Author: yingbin
 * @Date: 2019-08-29 13:20:14
 * @LastEditTime: 2019-09-25 13:14:40
 * @LastEditors: yingbin
 -->
<template>
  <div class="update-company-info">
    <div class="center-top">
      <p>
        <span>公司全称：</span>
        <span>{{companyInfo.companyName}}</span>
      </p>
      <p>
        <span>公司地址：</span>
        <span>{{companyInfo.companyProvince}}{{companyInfo.companyCity}}{{companyInfo.companyCounty}}{{companyInfo.conpanyDetailAddr}}</span>
      </p>
      <p>
        <span>所属行业：</span>
        <span>{{companyInfo.industry}}</span>
      </p>
      <p>
        <span>联系人姓名：</span>
        <span>{{companyInfo.contactName}}</span>
      </p>
      <p>
        <span>联系人手机：</span>
        <span>{{companyInfo.contactMobile}}</span>
      </p>
      <p>
        <span>统一社会信用代码：</span>
        <span>{{companyInfo.creditUnionCode}}</span>
      </p>
      <p>
        <span>三证合一证件：</span>
        <img class="img1" :src="companyInfo.cardImg" alt />
      </p>
    </div>
  </div>
</template>

<script>
import uitls from "@/utils/utils";
import company from "../../apis/company_apis";
export default {
  data() {
    return {
      companyInfo: {},
      operateInfo: {},
      barcodeUrl:'',
    };
  },
  created() {
    this.companyInfo = this.$parent.companyInfo;
    this.operateInfo = this.$parent.operateInfo;
  },
  mounted() {
    // this.getBarcode()
  },
  methods: {
    getBarcode() {
        this.$axio.get(this.companyInfo.cardImg,
            { 
              headers:{
               'token':uitls.getCookie('TOKEN')
              },
                //设定接收类型为blob,头部什么的自行添加
              responseType:'blob',
            }
        ).then(res=>{
          console.log(res)
        })
        //赋值给变量
        
          // this.barcodeUrl=URL.createObjectURL(result);
          // this.barcodeDialogVisible=true;
    },
  }
};
</script>

<style lang="less" scoped>
.update-company-info {
  padding: 30px 0 80px;
  font-size: 14px;
  color: #43425d;

  .center-top {
    padding-left: 50px;
    p {
      display: flex;
      line-height: 40px;

      & span:nth-child(1) {
        color: #969698;
        padding-right: 20px;
        flex-basis: 20%;
        text-align: right;
      }
    }
  }

  .img1 {
    width: 183px;
    height: 267px;
    cursor: pointer;
  }
}

.title {
  height: 80px;
  line-height: 80px;
  margin-bottom: 20px;
  color: #393737;
  font-size: 18px;
  border-bottom: 2px solid #e5e5e8;
  span {
    position: relative;
    top: 2px;
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 14px;
    border-radius: 50%;
    border: 4px solid #ee9808;
  }
}
</style>
